export default "__VITE_ASSET__BHwQ7$bg__"